export default {
  props: {
    packages: {
      validator(value) {
        return Array.isArray(value) && value.length > 0;
      },
    },
    selected: String,
    useBudget: Boolean,
  },
  computed: {
    packageCount() {
      return this.packages.length - 1;
    },
    selectedIndex() {
      const idx = this.packages.findIndex(p => p.name === this.selected);
      if (idx === -1) {
        this.$emit('update:selected', this.packages[0].name);
        return 0;
      }
      return idx;
    },
    price() {
      return this.packages[this.selectedIndex] ?
        this.packages[this.selectedIndex].price :
        0;
    },
    reach() {
      return this.packages[this.selectedIndex] ? this.packages[this.selectedIndex].reach : 0;
    },
    packageValue() {
      let key = this.reach;

      if (this.useBudget) {
        key = this.price;
      }

      return ({ value: key });
    },
    packageText() {
      if (this.useBudget) {
        return this.$t('pos.checkout.budget', { price: this.packageValue.value });
      }

      return this.$t('fn.number', this.packageValue);
    },
  },
  methods: {
    changePackage(direction) {
      let currIndex = this.selectedIndex;
      if (direction === 'up' && currIndex >= 1) {
        currIndex -= 1;
      } else if (direction === 'down' && currIndex < this.packageCount) {
        currIndex += 1;
      }
      if (currIndex !== this.selectedIndex) {
        this.$emit('update:selected', this.packages[currIndex].name);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/package-slider/PackageSlider.js